import api from '../../api/catUnitsRoutes.js';

const namespaced = true;
 
export const state = {
    unidades:[]
}

const mutations = {
    MUTATION_SET_UNITS(state, value){
        state.unidades = value;
    },
}

const actions = {
    getCatUnits(context){
        return new Promise((resolve, reject) => {
            api.getCatUnits().then(resp => {
                if (resp.status === 200) {
                    context.commit('MUTATION_SET_UNITS', resp.data);
                    resolve(resp.data);
                } else {
                    reject(new Error(resp.data?.message || 'Error al obtener catalogo de unidades'));
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
}

const getters = {
    getUnidades(state){
        return state.unidades;
    },
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}